import React from 'react'
import PropTypes from 'prop-types'

class ServantsTableList extends React.Component {

  getAvatar = (key) => {
    const { servants, avatars } = this.props

    if (servants && servants[key].avatar) {
      if (avatars && avatars[key]) {
        return avatars[key]
      }
    }
    return ''
  }

  getColor = (rankKey) => {
    if (this.props.ranks) {
      const rankColor = this.props.ranks[rankKey].color
      return rankColor && {color: rankColor}
    }
  }

  getStatus = (status) => {
    if (status) {
      return <img
        src="http://diablo.azmklan.org/grafika/aktywny.png"
        alt="active" title="Aktywny Klanowicz" height="15" width="15"/>
    }
    return <img
      src="http://diablo.azmklan.org/grafika/nieaktywny.png"
      alt="not-active" title="Nieaktywny Klanowicz" height="15" width="15"/>
  }
  render () {
    const { servants, ranks, servantRanks, paragons } = this.props
    return (
      <div>
        <div style={{
          backgroundImage: 'url(http://diablo.azmklan.org/grafika/g1.png)',
          backgroundPosition: 'center', width:370, height:26, margin:'auto'}}>&nbsp;</div>
        <table style={{
          width:370,
          background: 'rgba(0,0,0,0.6)',
          margin: '0 auto',
          border: '#392628 solid 1px'
        }}
               cellPadding="3" cellSpacing="0">
          <thead>
          <tr>
            <td style={{fontSize:11, color:'orange', border: '#392628 solid 1px'}}><strong>Ksywa</strong></td>
            <td style={{fontSize:11, color:'orange', border: '#392628 solid 1px'}}><strong>Paragon</strong></td>
            <td style={{fontSize:11, color:'orange', border: '#392628 solid 1px'}}><strong>Ranga</strong></td>
            <td style={{fontSize:11, color:'orange', border: '#392628 solid 1px'}}><strong>W AZM od</strong></td>
            <td style={{fontSize:11, color:'orange', border: '#392628 solid 1px'}}>&nbsp;</td>
          </tr>
          </thead>
          <tbody>
        { ranks && Object.keys(ranks).map(rankKey => (
          servantRanks && servantRanks[rankKey] &&
               servantRanks && Object.keys(servantRanks[rankKey]).map(key => (
                <tr key={key}>
                  <td style={{border: '#392628 solid 1px'}}>
                    <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].nick}
                      <a href={`http://eu.battle.net/d3/pl/profile/${servants[key].battleTag}/`}
                         target="_blank" rel="noopener noreferrer" title={servants[key].battleTag}>
                        <img src="http://diablo.azmklan.org//grafika/favicon.ico" height="13" alt="Profil"/>
                      </a>
                    </p>
                  </td>
                  <td style={{border: '#392628 solid 1px'}}>
                    <p className="paragon">
                       { paragons && servants[key] && paragons[servants[key].battleTag] ?
                        <span>
                          <span style={{'color':'green', 'fontSize':11}} className="no-paragon">{paragons[servants[key].battleTag].paragonLevel || 0}sc</span>
                          <span style={{'color':'red', 'fontSize':11}} className="hc-paragon">{paragons[servants[key].battleTag].paragonLevelHardcore || 0}hc</span>
                        </span> :
                         <span>{ servants[key].battleTag ? 'Loading' : 'Sekcja Diablo 2' }</span>
                      }
                    </p>
                  </td>
                  <td style={{border: '#392628 solid 1px'}}><p className="glowing-text" style={this.getColor(rankKey)}>{ranks[rankKey].single}</p></td>
                  <td style={{border: '#392628 solid 1px'}}><p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].since}</p></td>
                  <td style={{border: '#392628 solid 1px'}}><p className="glowing-text" style={this.getColor(rankKey)}>{this.getStatus(servants[key].status)}</p></td>
                </tr>
              ))
        ))}
        </tbody>
        </table>
        <div style={{
          backgroundImage: 'url(http://diablo.azmklan.org/grafika/g2.png)',
          backgroundPosition: 'center',width:370,height:26, margin:'auto'}}>&nbsp;</div>
      </div>
    )
  }
}

ServantsTableList.propTypes = {
  servants: PropTypes.object,
  avatars: PropTypes.object,
  ranks: PropTypes.object,
  servantRanks: PropTypes.object,
  paragons: PropTypes.object,
}

export default ServantsTableList



// WEBPACK FOOTER //
// ./src/components/ServantsTableList.js